import { Box, BoxProps, Drawer, DrawerContent } from "@chakra-ui/react";
import { useEffect, useMemo, useRef } from "react";
import Sidebar from "./components/sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import { commercialOptions, crmOptions, gestaoOptions, options } from "../../models/Home";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { hasScreenAccess } from "../../utils/screens";

interface SidebarRenderProps extends BoxProps {
  isMobile: boolean;
  onClose: () => void;
  isOpen: boolean;
}

export const SidebarRender = ({
  isMobile,
  onClose,
  isOpen,
  ...rest
}: SidebarRenderProps) => {
  const auth = useAuthUser<any>();
  const location = useLocation();

  const isCrm = location.pathname.startsWith("/crm") || location.pathname.startsWith("/commercial/crm");
  const isGestao = location.pathname.startsWith("/gestao");
  const isCommercial = location.pathname.startsWith("/commercial");

  const filteredOptions = isCrm
    ? crmOptions.filter((o) => hasScreenAccess(auth, o.link))
    : isGestao
    ? gestaoOptions.filter((o) => hasScreenAccess(auth, o.link))
    : isCommercial
    ? commercialOptions.filter((o) => hasScreenAccess(auth, o.link))
    : options
        .filter((o) =>
          auth?.position === 0 || auth?.position === 1
            ? ["/dashboard", "/documents", "/processes", "/financial"].includes(
                o.link
              )
            : auth?.position > 1 ||
              (o.link !== "/processes-status" &&
                o.link !== "/purchaseOrders" &&
                o.link !== "/commercial")
        )
        .filter((o) => hasScreenAccess(auth, o.link));
  if (isMobile) {
    return (
      <Drawer placement="left" onClose={onClose} isFullHeight isOpen={isOpen}>
        <DrawerContent
          p={0}
          m={0}
          pb="20px"
          w="200"
          h="100%"
          overflow="auto"
          sx={{
            scrollbarWidth: "thin",

            "::-webkit-scrollbar": {
              width: "4px",
            },
          }}
        >
          <Sidebar
            sideBarRoutes={filteredOptions}
            w="500px"
            h="full"
            pt="10"
            onClose={onClose}
            p={0}
            m={0}
            {...rest}
          />
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Box maxW="300px" h="100vh">
      <Sidebar onClose={onClose} sideBarRoutes={filteredOptions} {...rest} />
    </Box>
  );
};

export default SidebarRender;
